import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal }  from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }           from '../api/api.service';
import { CompanyService }       from '../companies/company.service';
import { MessagesService }      from '../messages/messages.service';
import { SessionService }       from '../sessions/session.service';
import { StreamSearchService }  from '../api/stream-search.service';
import { UKPostcodeService }    from '../uk-postcode/uk-postcode.service';

import { CustomerModel }       from '../customers/models/customer';
import { InvoiceModel }        from '../invoices/models/invoice';
import { LoanCarModel }        from './typings/loan-car';
import { LoanCarVehicleModel } from './typings/loan-car.vehicle';
import { SelectOption }        from '../core/models/select-option';

@Component({
  selector: 'wor-loan-car-create',
  template: `
    <div class="modal-header clearfix bg-info title">
      <h1 *ngIf="!loanCar?.id">
        <i class="fa fa-tag"></i>
        {{ 'LOAN_CAR_SPACE.CREATE_LOAN_CAR_BOOKING' | translate }}
      </h1>
      <h1 *ngIf="loanCar?.id">
        <i class="fa fa-tag"></i>
        {{ 'LOAN_CAR_SPACE.MODIFY_LOAN_CAR_BOOKING' | translate }}
        <span *ngIf="loanCar.invoice_id && !loanCar.event_id">
          {{ 'LOAN_CAR_SPACE.FOR_JOB' | translate : { job: invoice?.job_card_number } }}
        </span>
        <span *ngIf="!loanCar.invoice_id && loanCar.event_id">
          {{ 'LOAN_CAR_SPACE.FOR_BOOKING' | translate : { num: event?.event_number } }}
        </span>
        <span *ngIf="loanCar.invoice_id && loanCar.event_id">
          {{ 'LOAN_CAR_SPACE.FOR_BOOKING_JOB' | translate : { num: event?.event_number, job: invoice?.job_card_number } }}
        </span>
      </h1>
    </div>
    <form class="form-horizontal" #createForm="ngForm" novalidate
      (ngSubmit)="createForm.valid && save()">
      <div class="modal-body clearfix">
        <div class="row" *ngIf="context === 'base'">
          <fieldset class="col-sm-4">
            <label class="control-label"
              translate="LOAN_CAR_SPACE.SEARCH_CUSTOMER">
            </label>
            <div class="controls autocomplete">
              <input type="text" class="form-control"
                name="customer_search"
                [placeholder]="'CUSTOMER_SPACE.CHOOSE_A_CUSTOMER' | translate"
                [worTypeahead]="customerSearch"
                [(ngModel)]="customerSearch.value">
            </div>
          </fieldset>
          <fieldset class="col-sm-4">
            <label class="control-label"
              translate="LOAN_CAR_SPACE.SEARCH_BOOKINGS">
            </label>
            <div class="controls autocomplete">
              <input type="text" class="form-control"
                name="event_search"
                [placeholder]="'LOAN_CAR_SPACE.CHOOSE_A_BOOKING' | translate"
                [worTypeahead]="eventSearch"
                [(ngModel)]="eventSearch.value">
            </div>
          </fieldset>
          <fieldset class="col-sm-4">
            <label class="control-label"
              translate="LOAN_CAR_SPACE.SEARCH_INVOICES">
            </label>
            <div class="controls autocomplete">
              <input type="text" class="form-control"
                name="invoice_search"
                [placeholder]="'LOAN_CAR_SPACE.CHOOSE_AN_OPEN_INVOICE' | translate"
                [worTypeahead]="invoiceSearch"
                [(ngModel)]="invoiceSearch.value">
            </div>
          </fieldset>
        </div>
        <div class="row" *ngIf="context !== 'base'">
          <fieldset class="col-sm-4">
            <label class="control-label"
              translate="LOAN_CAR_SPACE.SEARCH_CUSTOMER">
            </label>
            <div class="controls autocomplete">
              <input type="text" class="form-control"
                name="customer_search"
                [placeholder]="'CUSTOMER_SPACE.CHOOSE_A_CUSTOMER' | translate"
                [worTypeahead]="customerSearch"
                [(ngModel)]="customerSearch.value">
            </div>
          </fieldset>
        </div>
        <div class="row">
          <fieldset class="col-md-4">
            <label class="control-label"
              translate="LOAN_CAR_SPACE.LOAN_DATE">
            </label>
            <wor-date-control
              name="loan_date"
              [(ngModel)]="loanCar.loan_date">
            </wor-date-control>
          </fieldset>
          <fieldset class="col-md-4">
            <label class="control-label required"
              translate="GENERAL_SPACE.FIELD.FIRST_NAME">
            </label>
            <input type="text" class="form-control"
              name="first_name" maxlength="50"
              [(ngModel)]="loanCar.contact_first_name">
          </fieldset>
          <fieldset class="col-md-4">
            <label class="control-label required"
              translate="GENERAL_SPACE.FIELD.LAST_NAME">
            </label>
            <input type="text" class="form-control"
              name="last_name" maxlength="50"
              [(ngModel)]="loanCar.contact_last_name">
          </fieldset>
        </div>
        <div class="row">
          <fieldset class="col-md-6"
            *ngIf="!companyService.country('newZealand')">
            <label class="control-label"
              [translate]="'GENERAL_SPACE.FIELD.ADDRESS'"
              [translateParams]="{ num: 1 }">
            </label>
            <input type="text" class="form-control"
              name="address1" maxlength="50"
              [(ngModel)]="loanCar.contact_address1">
          </fieldset>
          <fieldset class="col-md-6"
            *ngIf="companyService.country('newZealand')">
            <label class="control-label"
              [translate]="'GENERAL_SPACE.FIELD.ADDRESS'"
              [translateParams]="{ num: 1 }">
            </label>
            <input type="text" class="form-control"
              name="address1_nz"
              [placeholder]="'GENERAL_SPACE.FIELD.SEARCH_ADDRESSES' | translate"
              [(ngModel)]="loanCar.contact_address1">
          </fieldset>
          <fieldset class="col-md-6">
            <label class="control-label"
              [translate]="'GENERAL_SPACE.FIELD.ADDRESS'"
              [translateParams]="{ num: 2 }">
            </label>
            <input type="text" class="form-control"
              name="address2" maxlength="50"
              [(ngModel)]="loanCar.contact_address2">
          </fieldset>
        </div>
        <div class="row">
          <fieldset class="col-md-4">
            <label class="control-label"
              translate="GENERAL_SPACE.FIELD.SUBURB">
            </label>
            <input type="text" class="form-control"
              name="suburb" maxlength="30"
              [(ngModel)]="loanCar.contact_suburb">
          </fieldset>
          <fieldset class="col-md-4">
            <label class="control-label"
              [translate]="companyService.country('unitedKingdom') ? 'GENERAL_SPACE.FIELD.COUNTY' : 'GENERAL_SPACE.FIELD.STATE'">
            </label>
            <select class="form-control"
              name="state"
              [(ngModel)]="loanCar.contact_state">
              <option *ngFor="let s of states" [ngValue]="s.code">
                {{ s.language_label | translate }}
              </option>
            </select>
          </fieldset>
          <fieldset class="col-md-4">
            <label class="control-label"
              translate="GENERAL_SPACE.FIELD.POSTCODE">
            </label>
            <input type="text" class="form-control"
              name="contact_postcode"
              wor-postcode-validator
              [(ngModel)]="loanCar.contact_postcode"
              *ngIf="!companyService.hasIntegration('uk-postcode')">
            <div class="input-group"
              *ngIf="companyService.hasIntegration('uk-postcode')">
              <input type="text" class="form-control"
                name="contact_postcode" maxlength="10"
                [(ngModel)]="loanCar.contact_postcode">
              <span class="input-group-btn">
                <button type="button" class="btn btn-info"
                  (click)="searchUKPostcode()"
                  translate="GENERAL_SPACE.BUTTON.SEARCH">
                </button>
              </span>
            </div>
          </fieldset>
        </div>
        <div class="row">
          <fieldset class="col-md-4">
            <label class="control-label"
              translate="GENERAL_SPACE.FIELD.PHONE_NUMBER">
            </label>
            <input type="text" class="form-control"
              name="phone" maxlength="30"
              worPhoneValidator
              [(ngModel)]="loanCar.contact_phone">
          </fieldset>
          <fieldset class="col-md-4">
            <label class="control-label"
              translate="GENERAL_SPACE.FIELD.MOBILE">
            </label>
            <input type="text" class="form-control"
              name="mobile" maxlength="30"
              worPhoneValidator
              [(ngModel)]="loanCar.contact_mobile">
          </fieldset>
          <fieldset class="col-md-4">
            <label class="control-label"
              translate="GENERAL_SPACE.FIELD.EMAIL">
            </label>
            <input type="email" class="form-control"
              name="email" maxlength="60"
              [(ngModel)]="loanCar.contact_email">
          </fieldset>
        </div>
        <div class="row">
          <fieldset class="col-sm-12" *ngIf="!loanCar?.id">
            <label class="control-label"
              translate="LOAN_CAR_SPACE.SEARCH_LOAN_VEHICLES">
            </label>
            <div class="col-sm-4 controls autocomplete">
              <input type="text" class="form-control"
                name="loan_vehicle_search"
                [placeholder]="'LOAN_CAR_SPACE.CHOOSE_AVAILABLE_LOAN_VEHICLE' | translate"
                [worTypeahead]="loanVehicleSearch"
                [(ngModel)]="loanVehicleSearch.value">
            </div>
            <div class="col-sm-8" *ngIf="loanCar.loan_vehicle_id">
              <p>
                <span>{{ loanVehicle?.plate_number }}</span>
                <span> - {{ loanVehicle?.make }}</span>
                <span> {{ loanVehicle?.model }}</span>
                <span> {{ loanVehicle?.model_code }}</span>
                <span> {{ loanVehicle?.model_series }}</span>
                <span> - {{ loanVehicle?.build_date }}</span>
                <span> - {{ loanVehicle?.colour }}</span>
              </p>
            </div>
          </fieldset>
          <fieldset class="col-md-12" *ngIf="loanCar?.id">
            <label class="control-label"
              translate="LOAN_CAR_SPACE.LOAN_VEHICLE">
            </label>
            <div class="col-md-4 controls">
              <select class="form-control"
                name="available_vehicle"
                [(ngModel)]="loanCar.loan_vehicle_id">
                <option *ngFor="let v of availableVehicles" [ngValue]="v.id">
                  {{ v.plate_number }}
                </option>
              </select>
            </div>
            <div class="col-sm-8" *ngIf="loanCar.loan_vehicle_id">
              <p>
                <span>{{ loanVehicle?.plate_number }}</span>
                <span> - {{ loanVehicle?.make }}</span>
                <span> {{ loanVehicle?.model }}</span>
                <span> {{ loanVehicle?.model_code }}</span>
                <span> {{ loanVehicle?.model_series }}</span>
                <span> - {{ loanVehicle?.build_date }}</span>
                <span> - {{ loanVehicle?.colour }}</span>
              </p>
            </div>
          </fieldset>
        </div>
        <div class="row">
          <hr>
        </div>
        <div class="row">
          <fieldset class="col-md-6">
            <label class="control-label required"
              translate="SERVICE_REMINDERS_SPACE.START_DATE">
            </label>
            <wor-date-control
              name="start_date"
              [required]="true"
              [(ngModel)]="serviceInstance.loanCar.start_date">
            </wor-date-control>
          </fieldset>
          <fieldset class="col-md-6">
            <label class="control-label"
              translate="BOOKING_SPACE.START_TIME">
            </label>
            <div class="input-group controls">
              <span class="input-group-addon date">
                <i class="fa fa-clock-o"></i>
              </span>
              <input type="text" class="form-control"
                name="start_time"
                [(ngModel)]="serviceInstance.loanCar.start_time"
                readonly>
            </div>
          </fieldset>
        </div>
        <div class="row">
          <fieldset class="col-md-6">
            <label class="control-label required"
              translate="LOAN_CAR_SPACE.RETURN_DATE">
            </label>
            <wor-date-control
              name="return_date"
              [required]="true"
              [(ngModel)]="serviceInstance.loanCar.return_date">
            </wor-date-control>
          </fieldset>
          <fieldset class="col-md-6">
            <label class="control-label"
              translate="LOAN_CAR_SPACE.RETURN_TIME">
            </label>
            <div class="input-group controls">
              <span class="input-group-addon date">
                <i class="fa fa-clock-o"></i>
              </span>
              <input type="text" class="form-control"
                name="return_time"
                [(ngModel)]="serviceInstance.loanCar.return_time"
                readonly>
            </div>
          </fieldset>
        </div>
      </div>
      <div class="modal-footer d-flex align-items-center">
        <button type="button" class="btn btn-default"
          (click)="modal.dismiss()"
          translate="GENERAL_SPACE.BUTTON.CANCEL">
        </button>
        <button type="submit" class="btn btn-success m-left-auto"
          [disabled]="createForm.invalid">
          {{ (loanCar?.id ? 'GENERAL_SPACE.BUTTON.UPDATE' : 'GENERAL_SPACE.BUTTON.CREATE') | translate }}
        </button>
      </div>
    </form>
  `
})
export class LoanCarCreateComponent implements OnInit {
  @Input() context          : 'base' | 'event' | 'invoice' = 'base';
  @Input() loanCar          : LoanCarModel = {};
  @Input() loanVehicle      : LoanCarVehicleModel;
  @Input() customer         : CustomerModel;
  @Input() event            : { id?: string; event_number?: string; customer_id?: string };
  @Input() invoice          : InvoiceModel;
  @Input() states           : SelectOption[] = [];
  @Input() availableVehicles: LoanCarVehicleModel[] = [];
  @Input() serviceInstance  : { loanCar: LoanCarModel; save: (loanCar: LoanCarModel) => Promise<LoanCarModel> };
  @Input() onSaveComplete   : (data?: LoanCarModel) => void;

  regoLabel = '';

  customerSearch    : Record<string, unknown>;
  eventSearch       : Record<string, unknown>;
  invoiceSearch     : Record<string, unknown>;
  loanVehicleSearch : Record<string, unknown>;

  constructor (
    public  modal               : NgbActiveModal,
    public  companyService      : CompanyService,
    private apiService          : ApiService,
    private messagesService     : MessagesService,
    private sessionService      : SessionService,
    private streamSearchService : StreamSearchService,
    private translateService    : TranslateService,
    private ukPostcodeService   : UKPostcodeService
  ) {}

  ngOnInit (): void {
    const company = this.sessionService.company();

    this.regoLabel = company?.company_variable_fields?.plate_number_name
      || this.sessionService.countrySettings()?.rego_label || '';

    this.customerSearch = {
      value : this.customer?.display_name || '',
      query : (typed: string) => this.streamSearchService.search('customers', typed),
      format: (customer: CustomerModel) => customer ? customer.display_name : '',
      choose: (customer: CustomerModel) => {
        this.customer = customer;
        this.loanCar.customer_id          = customer.id;
        this.loanCar.contact_first_name   = customer.first_name;
        this.loanCar.contact_last_name    = customer.last_name;
        this.loanCar.contact_address1     = customer.address1;
        this.loanCar.contact_address2     = customer.address2;
        this.loanCar.contact_suburb       = customer.suburb;
        this.loanCar.contact_state        = customer.state;
        this.loanCar.contact_postcode     = customer.postcode;
        this.loanCar.contact_phone        = customer.phone;
        this.loanCar.contact_mobile       = customer.mobile;
        this.loanCar.contact_email        = customer.email;
      }
    };

    this.loanVehicleSearch = {
      value : this.loanVehicle?.plate_number || '',
      query : (typed: string) => this.streamSearchService.search('loan_vehicles', typed),
      format: (vehicle: LoanCarVehicleModel) => vehicle ? vehicle.plate_number : '',
      choose: (vehicle: LoanCarVehicleModel) => {
        this.loanVehicle = vehicle;
        this.loanCar.loan_vehicle_id = vehicle.id;
      }
    };

    if (this.context === 'base') {
      this.invoiceSearch = {
        value : '',
        query : (typed: string) => this.streamSearchService.search('invoices', typed),
        format: (invoice: InvoiceModel) => invoice ? invoice.job_card_number : '',
        choose: (invoice: InvoiceModel) => {
          this.invoice = invoice;

          if (invoice.event_id) {
            this.apiService.get('/event', invoice.event_id).then(event => {
              this.event = event;
            });
          }

          this.apiService.get('/customer', invoice.customer_id).then((customer: CustomerModel) => {
            this.customer = customer;
            this.loanCar.customer_id          = invoice.customer_id;
            this.loanCar.invoice_id           = invoice.id;
            this.loanCar.event_id             = invoice.event_id;
            this.loanCar.contact_first_name   = customer.first_name;
            this.loanCar.contact_last_name    = customer.last_name;
            this.loanCar.contact_address1     = customer.address1;
            this.loanCar.contact_address2     = customer.address2;
            this.loanCar.contact_suburb       = customer.suburb;
            this.loanCar.contact_state        = customer.state;
            this.loanCar.contact_postcode     = customer.postcode;
            this.loanCar.contact_phone        = customer.phone;
            this.loanCar.contact_mobile       = customer.mobile;
            this.loanCar.contact_email        = customer.email;
          });
        }
      };

      this.eventSearch = {
        value : '',
        query : (typed: string) => this.streamSearchService.search('events', typed),
        format: (event: { event_number?: string }) => event ? event.event_number : '',
        choose: (event: { id?: string; event_number?: string; customer_id?: string }) => {
          this.event = event;

          this.apiService.get('/customer', event.customer_id).then((customer: CustomerModel) => {
            this.customer = customer;
            this.loanCar.customer_id          = event.customer_id;
            this.loanCar.event_id             = event.id;
            this.loanCar.contact_first_name   = customer.first_name;
            this.loanCar.contact_last_name    = customer.last_name;
            this.loanCar.contact_address1     = customer.address1;
            this.loanCar.contact_address2     = customer.address2;
            this.loanCar.contact_suburb       = customer.suburb;
            this.loanCar.contact_state        = customer.state;
            this.loanCar.contact_postcode     = customer.postcode;
            this.loanCar.contact_phone        = customer.phone;
            this.loanCar.contact_mobile       = customer.mobile;
            this.loanCar.contact_email        = customer.email;
          });
        }
      };
    }
  }

  save (): void {
    const isModify = !!this.loanCar?.id;

    this.serviceInstance.save(this.loanCar)
      .then((data: LoanCarModel) => {
        this.modal.close(data);
        this.messagesService.show(
          this.translateService.instant(
            isModify
              ? 'LOAN_CAR_SPACE.LOAN_CAR_BOOKING_UPDATED'
              : 'LOAN_CAR_SPACE.LOAN_CAR_BOOKING_CREATED'
          ),
          'success'
        );

        if (this.onSaveComplete) {
          this.onSaveComplete(data);
        }
      })
      .catch((err: unknown) => this.messagesService.error(err));
  }

  searchUKPostcode (): void {
    this.ukPostcodeService.search(this.loanCar.contact_postcode)
      .then((data: { Premises: string; Street: string; PostTown: string; Postcode: string }) => {
        this.loanCar.contact_address1 = data.Premises;
        this.loanCar.contact_address2 = data.Street;
        this.loanCar.contact_suburb   = data.PostTown;
        this.loanCar.contact_postcode = data.Postcode;

        this.messagesService.show(
          this.translateService.instant('CUSTOMER_SPACE.CUSTOMER_ADDRESS_UPDATED'),
          'success'
        );
      })
      .catch((err: unknown) => this.messagesService.error(err));
  }
}
